<template>
<div>
    <mdb-streak lg :quote="quote" :by="by" :picture="hero_image" overlayClass="white-text rgba-black-light" />
</div>
</template>

<script>
import {
    mdbStreak
} from 'mdbvue'
import portada from '../assets/portada.jpg'

export default {
    name: 'Streak',
    data() {
        return {
            hero_image: portada,
            quote: 'Paradise Apartments',
            by: 'El Paraiso esta a su Alcance',
        }
    },
    components: {
        mdbStreak
    },
}
</script>

<style lang="css">
.fa-quote-left,
.fa-quote-right {
    display: none;
}

.font-italic {
    font-style: normal !important;
}
</style>
